<!-- <h4 class="h4">(Driver Courier)</h4> -->
<div class="main-content pt-4 mt-0">
  <div class="container-fluid">
    <div class="row justify-content-center mb-0">
      <div
        class="col column"
        *ngFor="let card of resumenCardsTwo; let i = index"
      >
        <div
          class="card card-stats__two"
          [ngClass]="{ 'card-stats__two--selected': i === 2 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-7 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 2, 'text-white': i !== 2 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 2 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 1 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-7 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 1, 'text-white': i !== 1 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 1 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <div class="card-tools pb-5 pt-2">
          <div class="row">
            <div class="col-12">
              <a
                class="btn btn-dark btn-sm btn-new"
                [routerLink]="['/logistics/fees/volume']"
              >
                Customer Charges
              </a>
              <a
                [routerLink]="['/logistics/fees/driverVolume']"
                class="btn btn-light btn-sm btn-fees"
              >
                Driver Fees
              </a>
            </div>
            <!-- <div class="col-6">
              <h2><strong>CUSTOMER CHARGES</strong></h2>
            </div> -->
          </div>
        </div>
        <div class="card">
          <div class="card-header card-header-icon">
            <div class="card-icon">
              <i class="material-icons">receipt</i>
            </div>
            <h4 class="card-title">{{ id ? "Update" : "New" }} Volume Fees</h4>
          </div>
          <div class="card-body">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <!-- Información Básica -->
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="code">Code</label>
                    <input
                      type="text"
                      class="form-control"
                      id="code"
                      formControlName="code"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('code')"
                    >
                      Code is required
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="name">Name</label>
                    <input
                      type="text"
                      class="form-control"
                      id="name"
                      formControlName="name"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('name')"
                    >
                      Name is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="value">Value</label>
                    <input
                      type="text"
                      class="form-control"
                      id="value"
                      formControlName="value"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('value')"
                    >
                      Value is required
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 d-flex justify-content-center">
                  <div
                    class="form-group d-flex justify-content-center align-items-center gap-4"
                  >
                    <div class="custom-control custom-switch mt-4 checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="status"
                        formControlName="status"
                      />
                      <label class="custom-control-label" for="status"
                        >Active</label
                      >
                    </div>
                  </div>
                </div>
              </div>

              <div class="row text-center">
                <div class="col-md-12">
                  <button
                    type="submit"
                    class="btn btn-dark pull-right btn-create"
                    [disabled]="form.invalid"
                  >
                    {{ id ? "Update" : "Create" }}
                  </button>
                </div>
              </div>
              <div class="clearfix"></div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
